import React from 'react'
import { Tooltip } from '@mui/material'
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined'
import NoAccountsOutlinedIcon from '@mui/icons-material/NoAccountsOutlined'
import { colors } from '@resiliatech/birdsong'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { User } from 'TypeDefs/Goal'
import { AddOwner, AvatarAction, OwnerContainer } from './TaskItem.styled'
import { UserAvatarV2 } from './UserAvatarV2'

type TaskOwnerContentProps = {
  owner: User | null
  onAvatarClick: (event: React.MouseEvent<HTMLElement>) => void
  disabled: boolean
}

export const TaskOwnerContent: React.FC<TaskOwnerContentProps> = ({
  owner,
  onAvatarClick,
  disabled,
}) => {
  const { teamMap } = useNonprofitOrgTeam()

  const getOwnerData = (user: User | null) => {
    if (!user || !user.id) return user
    if (!teamMap) return user
    const teamMember = teamMap[user.id.toString()]
    return teamMember || user
  }

  const ownerData = getOwnerData(owner)

  if (
    ownerData &&
    (!ownerData.firstName || ownerData.firstName.trim() === '')
  ) {
    return (
      <OwnerContainer>
        <AddOwner
          data-testid='assignOwnerButton'
          disabled={disabled}
          onClick={onAvatarClick}
        >
          {owner && owner.id ? (
            <Tooltip
              title='This user is no longer with your team. Please assign a new owner.'
              arrow
            >
              <NoAccountsOutlinedIcon
                data-testid='ownerAssignedToTaskButNoNameIcon'
                sx={{ color: colors.feedback.warningDark }}
              />
            </Tooltip>
          ) : (
            <PersonAddAltOutlinedIcon />
          )}
        </AddOwner>
      </OwnerContainer>
    )
  }

  if (ownerData && ownerData.firstName && ownerData.firstName.trim() !== '') {
    return (
      <OwnerContainer>
        <AvatarAction onClick={onAvatarClick}>
          <UserAvatarV2 user={owner} />
        </AvatarAction>
      </OwnerContainer>
    )
  }

  return (
    <OwnerContainer>
      <AddOwner data-testid='assignOwnerButton' onClick={onAvatarClick}>
        <PersonAddAltOutlinedIcon />
      </AddOwner>
    </OwnerContainer>
  )
}
